import { Node, mergeAttributes } from "@tiptap/core";

export const ImageUploadPlaceholder = Node.create({
  name: "imageUploadPlaceholder",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      id: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-image-upload-placeholder]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, { "data-image-upload-placeholder": "" }),
    ];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("span");
      dom.className = "image-upload-placeholder";
      dom.dataset.placeholderId = node.attrs.id;
      dom.innerHTML = `
        <span class="image-upload-placeholder-inner">
          <span class="image-upload-placeholder-spinner"></span>
          <span class="image-upload-placeholder-label">Uploading...</span>
        </span>`;
      return { dom };
    };
  },
});
